var DataTable = require('../util/data-table');
var PrintElement = require('../util/print-element');

var Orders = function(el, options) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = options || {};
    this.init();
};

Orders.prototype = {
    constructor: Orders,
    $el: undefined,
    options: undefined,
    dataTable: undefined,
    currentCategory: undefined,
    init: function() {
        var self = this;

        self.currentCategory = self.$el.find('.table').attr('data-category');

        self.$el.find('.filters').on('change', '.filter', function() {
            var $this=  $(this);
            self.updateFilterBadges();
            self.dataTable.$el.bootstrapTable('refresh');
        });

        var preloadedSearch;
        if (self.$el.find('.table').attr('data-search-term')) {
            preloadedSearch = self.$el.find('.table').attr('data-search-term');
        }

        self.$el.find('.table').on('click', 'a', function(evt) {
            var $this = $(evt.currentTarget),
                actionType = $this.attr('data-bs-title');
            if (['Edit', 'Print', 'Email'].indexOf(actionType) === -1) {
                evt.preventDefault();
                self['handle' + actionType + 'Click']($this);
                return false;
            }
            else if (actionType == 'Email') {
                evt.preventDefault();
                $.get($this.attr('href')).then(function() {
                    alert('Email sent.');
                });
                return false;
            }
            else if (actionType == 'Print') {
                evt.preventDefault();
                self.openPrintModel($this.attr('href'));
                return false;
            }
        });

        window.ordersDirectoryQueryParams = function(params) { return self.queryParams(params); };
        self.initTable();
        $('table').on('post-body.bs.table', function() {
            var $table = $(this);
            console.log('body loaded');
            $.get('/admin/orders/api/data?multiple-orders=1&Holiday=' + $('#order_holiday').val()).then(function(response) {
                $table.find('tbody tr').each(function() {
                    var $row = $(this);
                    $row.toggleClass('table-primary', response.indexOf(parseInt($row.find('td')[0].innerHTML)) !== -1);
                });
            });
        });
        self.dataTable.init();

        $('#standard-modal').on('click', '.notes-btn', function(evt) {
            var $button = $(this);
            var $row = $(`
                <tr data-order-id="${$button.data('orderId')}" data-id="">
                    <td><textarea class="form-control notes-control" style="height: 71px;"></textarea></td>
                    <td class="collapsed-col">
                        <select class="form-select d-block mb-1 notes-type" style="width: 100px;"> 
                            <option value="0">System</option>
                            <option value="1">User</option>
                        </select>
                        <button class="btn btn-outline-danger btn-sm notes-delete-btn d-block w-100 border-0"><i class="bi bi-trash-fill"></i></button>
                    </td>
                </tr>
            `);
            $('.notes-table tbody').append($row);
        });

        var updateNote = function($row, cb) {
            var $spinner = $row.closest('.col-12').find('h3 .spinner-grow'),
                $textarea = $row.find('textarea'),
                $select = $row.find('select'),
                del = del || false;
            $spinner.removeClass('d-none');
            var data = { notes: $textarea.val(), type: $select.val(), id: $row.attr('data-id'), orderId: $row.attr('data-order-id') };
            if (del) {
                delete data.notes;
                delete data.type;
                data.delete = true;
            }
            $.post('/admin/orders/api/notes-update/' + $row.attr('data-order-id'), data).done(function(response) {
                if (response.id) {
                    $row.attr('data-id', response.id);
                }
                $spinner.addClass('d-none');
                (cb || function() {})();
            });
        };

        var deleteNote = function($row, cb) {
            var $spinner = $row.closest('.col-12').find('h3 .spinner-grow'),
                del = del || false;
            $spinner.removeClass('d-none');
            var data = { id: $row.attr('data-id'), orderId: $row.attr('data-order-id'), delete: true };
            $.post('/admin/orders/api/notes-update/' + $row.attr('data-order-id'), data).done(function(response) {
                $spinner.addClass('d-none');
                (cb || function() {})();
            });
        };

        var markPaid = function($row, cb) {
            var $spinner = $row.find('.spinner-grow');
            $spinner.removeClass('d-none');
            $.post('/admin/orders/api/mark-paid/' + $row.attr('data-order-id')).done(function(response) {
                $spinner.addClass('d-none');
                (cb || function() {})(response);
            });
        };

        $('#standard-modal').on('click', '.mark-paid-btn', function(evt) {
            var $row = $(this).closest('tr');
            markPaid($(this).closest('tr'), function(response) {
                var $td = $row.find('.paid-on-col');
                $td.html(response.paid_on);
                self.dataTable.$el.bootstrapTable('refresh');
            });
        });

        $('#standard-modal').on('click', '.notes-delete-btn', function(evt) {
            deleteNote($(this).closest('tr'), function() {
                $(evt.currentTarget).closest('tr').remove();
            });
        });

        $('#standard-modal').on('blur', '.notes-control', function(evt) {
            updateNote($(this).closest('tr'));
        });

        $('#standard-modal').on('change', '.notes-type', function(evt) {
            updateNote($(this).closest('tr'));
        });

        self.updateFilterBadges();

        if (preloadedSearch) {
            self.$el.find('.form-control.search-input').val(preloadedSearch);
            self.$el.find('.form-control.search-input').trigger('keyup');
        }

        self.$el.on('click', '.print-btn', function() {
            var $this = $(this);

            var filters = self.getFilters();
            var url = $this.attr('data-url');
            for (var key in filters) {
                if (filters[key]) {
                    url += (url.indexOf('?') !== -1 ? '&' : '?') + key + '=' + filters[key];
                }
            }

            self.openPrintModel(url);
        });

        $('.holiday-select').on('change', function() {
            self.updateDinnerPrintOptions();
        });

        this.updateDinnerPrintOptions();

        $('#standard-modal').on('change', '.status-select', function() {
            var $this = $(this),
                $spinner = $this.closest('td').find('.spinner-grow'),
                map = {
                    1: 'bg-warning',
                    2: 'bg-primary',
                    3: 'bg-success',
                    4: 'bg-secondary'
                };
            $this.removeClass(Object.values(map));
            $this.addClass(map[$this.val()]);
            $spinner.removeClass('d-none');
            $.post('/admin/orders/api/status-update/' + $this.attr('data-id'), { status: $this.val(), id: $this.attr('data-id') }).done(function(response) {
                $spinner.addClass('d-none');
                self.dataTable.$el.bootstrapTable('refresh');
            });
        });

        self.$el.find('.table').on('click', '.status-select-inline-dropdown .status-select-inline', function(evt) {
            var $this = $(this),
                $spinner = $this.closest('td').find('.spinner-grow'),
                $dropdownToggle = $this.closest('.dropdown').find('.dropdown-toggle'),
                map = {
                    1: 'bg-warning',
                    2: 'bg-primary',
                    3: 'bg-success',
                    4: 'bg-secondary'
                };
            $spinner.removeClass('d-none');
            $dropdownToggle.removeClass(Object.values(map));
            $dropdownToggle.addClass(map[$this.attr('data-status-id')]);
            $dropdownToggle.html($this.html());
            bootstrap.Dropdown.getOrCreateInstance($this.closest('.dropdown')).hide();
            $.post('/admin/orders/api/status-update/' + $this.attr('data-id'), { status: $this.attr('data-status-id'), id: $this.attr('data-id') }).done(function(response) {
                $spinner.addClass('d-none');
                if ($this.attr('data-status-id') == '3') {
                    // Status 3 is Picked Up, trigger print dialog.
                    $this.closest('tr').find('.print-btn').trigger('click');
                }
            });
            
            evt.preventDefault();
            return false;
        });

        // print & update
        $('.btn-print-update').on('click', function(evt) {
            var $form = $('form.pickup-form');
            evt.preventDefault();
            $.post('/admin/orders/pickup-print', {
                data: $form.serialize(),
            }).then(function(response) {
                console.log(response);
            });
            return false;
        });
    },
    updateDinnerPrintOptions: function() {
        var $holidaySelect = $('.holiday-select'),
            $dropdown = $('.print-dropdown-menu');
        $.get('/admin/orders/print?action=options&holiday=' + $holidaySelect.val()).then(function(response) {
            $dropdown.find('li:not(.default-list-item)').remove();
            var $defaultBtn = $($dropdown.find('.default-btn')[0]);
            response.forEach(function(item) {
                var $clone = $defaultBtn.clone();
                $clone.removeClass('default-btn');

                $clone.html(item.name);
                $clone.attr('data-url', item.url);

                var $li = $('<li>');
                $li.append($clone);

                $dropdown.append($li);
            });
        });
    },
    initTable: function() {
        var self = this;
        self.dataTable = new DataTable(self.$el.find('.table'), {
            height: true,
            autoInit: false
        });
    },
    queryParams: function(params) {
        var self = this;
        params.category = self.currentCategory;
        var filters = Object.assign(params, this.getFilters());
        if (filters.search && filters.search !== '') {
            filters.search = filters.search.replace(/(\d{3})(\)\s)(\d{3})/, '$1)$3');
        }
        return filters;
    },
    getFilters: function() {
        var self = this;
        var filters = {};
        self.$el.find('.filter').each(function() {
            filters[this.getAttribute('data-key')] = this.value;
        });
        return filters;
    },
    updateFilterBadges: function() {
        var self = this;
        var filters = self.getFilters();
        var labels = [];
        for (var key in filters) {
            if (filters.hasOwnProperty(key) && filters[key]) {
                var labelKey = key.charAt(0).toUpperCase() + key.slice(1);
                var $filter = $('.filter[data-key="' + key + '"');
                var labelValue = $filter.length && $filter[0].tagName.toLowerCase() === 'select'
                    ? $filter.find('option:selected').text()
                    : filters[key];
                labels.push('<span class="badge bg-primary mx-1">' + labelKey + ': ' + labelValue + '</span>')
            }
        }
        $('.filter-badges .card-body').html(labels.join(''));
        $('.filter-badges')[labels.length ? 'removeClass' : 'addClass']('d-none');
    },
    handleViewClick: function($btn) {
        $.get($btn.attr('href')).done(function(response) {
            var $modal = $('#standard-modal');
            $modal.find('.modal-header h5').html('Order View');
            $modal.find('.modal-body').html(response.body);
            $modal.find('.modal-footer').html(response.footer);
            $modal.find('.modal-dialog').addClass('modal-xl');
            var instance = bootstrap.Modal.getOrCreateInstance('#standard-modal');
            instance.show();
        });
    },
    handleDeleteClick: function($btn) {
        var self = this;
        console.log($btn.attr('href').match(/\d+$/));
        if (confirm(`Are you sure you want to delete order ${$btn.attr('href').match(/\d+$/)[0]}?`)) {
            $.get($btn.attr('href')).done(function(response) {
                self.dataTable.$el.bootstrapTable('refresh');
            });
        }
    },
    openPrintModel: function(url) {
        $.get(url).done(function(response) {
            var iframe = document.createElement('iframe');
            iframe.classList.add('visually-hidden');
            document.body.append(iframe);
            iframe.contentWindow.document.open();
            iframe.contentWindow.document.write(response);
            iframe.contentWindow.document.close();
            iframe.contentWindow.onafterprint = function() {
                iframe.remove();
            };
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        });
    }
};

module.exports = Orders;